import { render, staticRenderFns } from "./UserPastCourses.vue?vue&type=template&id=79b8b76f&"
import script from "./UserPastCourses.vue?vue&type=script&lang=js&"
export * from "./UserPastCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports